import React from "react";

import review1 from "../../../image/review-star1.webp";
import review2 from "../../../image/review-star2.webp";
import review3 from "../../../image/review-star3.webp";

const UserFeedback = () => {
  const reviews = [
    {
      img: review1,
      name: "Emma R",
      designation: "Marketing Manager",
      text: "Boosted engagement rates with AI personalization and perfect send-time optimization!",
      dataaosduration: "500",
    },
    {
      img: review2,
      name: "Scott D",
      designation: "SaaS Founder",
      text: "Time-saving automation delivers consistently amazing newsletter results effortlessly.",
      dataaosduration: "750",
    },
    {
      img: review3,
      name: "Harshad S",
      designation: "E-commerce Owner",
      text: "Behavior insights significantly increased our click-through rates and customer retention!",
      dataaosduration: "1000",
    },
  ];
  return (
    <>
      <h2 className="lp-product-heading">Users Feedback</h2>

      <h2 className="lp-heading">From our beta users</h2>

      <p className="lp-heading-desc">
        Trust Newslettrai to revolutionize your newsletter campaigns.
      </p>

      <div className="lp-container">
        <div className="lp-product-section">
          {reviews.map((review, index) => (
            <div
              key={index}
              className="lp-product-card user-card2"
              data-aos="fade-up"
              data-aos-duration={review.dataaosduration}
            >
              <img src={review.img} alt={review.name} />
              <h3>{review.name}</h3>
              <span>{review.designation}</span>
              <p className="lp-text">{review.text}</p>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default UserFeedback;
